import React from 'react';
import "styles/components/menu/company/OrganizationTab.scss";
import styled from 'styled-components';
import organization from 'assets/images/company/organization.png';

const Img = styled.div`
    width: 100%;
    height: 0;
    padding-top: calc(793 / 1383 * 100%);
    background : url(${props => props.src}) center left / cover no-repeat;
    margin: auto;
    margin-bottom: 2rem;
`;

const OrganizationTab = () => {
    return (
        <section className='OrganizationTab'>
            <div className="OrganizationTab-wrapper">
                <div className="title">
                    <span className="fw-bold">실력과 신의</span>를 기반으로 <br className='lineBreak' /><span className="fw-bold">최고</span>를 지향하는 <br className='lineBreak pc' />
                    <span className="fw-bold">어질인소프트</span>가 되겠습니다
                </div>
                <Img src={organization} />
            </div>
        </section>
    );
};

export default React.memo(OrganizationTab);